import { RoleDto } from './index';

export class RoleFilterResult {
  data: Array<RoleDto>;
  totalElements: number;
}
